export const GOOGLE_SERVICE_AUTH_URL = "GOOGLE_SERVICE_AUTH_URL";
export const GOOGLE_STORE_TOKEN = "GOOGLE_STORE_TOKEN";
export const GOOGLE_G_DRIVE_IMPORT = "GOOGLE_G_DRIVE_IMPORT";
